export default __webpack_public_path__ + "static/tdic-en-97f1e28806e7983b393f00a3dd15463c.mp4";